import { ExcalidrawOrchestrator } from '../orchestrators/excalidraw_orchestrator';
import { RawVisionFrame } from '../architecture/mosaic_pipeline';

class EventBus {
  private listeners = new Map<string, Function[]>();
  subscribe(topic: string, callback: Function) {
    if (!this.listeners.has(topic)) this.listeners.set(topic, []);
    this.listeners.get(topic)!.push(callback);
  }
  publish(topic: string, payload: any) {
    if (this.listeners.has(topic)) {
      this.listeners.get(topic)!.forEach(cb => cb(payload));
    }
  }
}

async function bootGoldenMaster() {
  console.log('[HFO_GOLDEN_MASTER] Booting v17b deterministic pipeline...');

  const eventBus = new EventBus();
  const orchestrator = new ExcalidrawOrchestrator(eventBus);
  orchestrator.boot();

  const videoEl = document.getElementById('mp4-source') as HTMLVideoElement;
  const bootOverlay = document.getElementById('boot-overlay') as HTMLElement;
  const btnReplay = document.getElementById('btn-replay-json');
  const btnRecord = document.getElementById('btn-record-json');
  const iframe = document.getElementById('excalidraw-iframe') as HTMLIFrameElement;
  const cursorEl = document.getElementById('debug-cursor') as HTMLDivElement;

  // Listen to the final intent to drive the debug cursor visually
  eventBus.subscribe('PIPELINE_FINAL_INTENT', (frame: any) => {
    if (!frame) return;
    cursorEl.style.display = 'block';
    
    // Convert normalized coordinates to screen pixels
    const screenX = frame.smoothedX * window.innerWidth;
    const screenY = frame.smoothedY * window.innerHeight;
    cursorEl.style.left = `${screenX}px`;
    cursorEl.style.top = `${screenY}px`;
    
    if (frame.isPinching) {
        cursorEl.classList.add('pinching');
    } else {
        cursorEl.classList.remove('pinching');
    }
  });

  // REPLAY MODE
  btnReplay?.addEventListener('click', async () => {
      bootOverlay!.style.display = 'none';
      try {
          const res = await fetch('../../golden_master.json');
          const frames = await res.json();
          let i = 0;
          const tick = () => {
              if (i >= frames.length) return;
              eventBus.publish('RAW_VISION_FRAME', frames[i++]);
              setTimeout(() => requestAnimationFrame(tick), 16);
          };
          requestAnimationFrame(tick);
      } catch (e) {
          console.error("No JSON found. Please Record first.", e);
      }
  });

  // RECORD MODE
  let isRecording = false;
  let recordedFrames: any[] = [];
  let startTime = 0;

  btnRecord?.addEventListener('click', () => {
      if (!isRecording) {
          isRecording = true;
          recordedFrames = [];
          startTime = performance.now();
          bootOverlay!.style.background = 'transparent';
          btnReplay!.style.display = 'none';
          btnRecord!.textContent = 'STOP & SAVE JSON';
          btnRecord!.style.position = 'absolute';
          btnRecord!.style.top = '10px';
          btnRecord!.style.right = '10px';
      } else {
          isRecording = false;
          const blob = new Blob([JSON.stringify(recordedFrames, null, 2)], { type: 'application/json' });
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'golden_master.json';
          a.click();
          window.location.reload();
      }
  });

  // Capture trusted mouse events to Author Telemetry
  const captureMouse = (e: MouseEvent) => {
      if (!isRecording || !e.isTrusted) return;
      recordedFrames.push({
          nowMs: performance.now() - startTime,
          handIndex: 0,
          gestureLabel: e.buttons > 0 ? 'pointer_up' : 'open_palm',
          confidence: 0.99,
          x: e.clientX / window.innerWidth,
          y: e.clientY / window.innerHeight,
          rawLandmarks: Array(21).fill({x: e.clientX / window.innerWidth, y: e.clientY / window.innerHeight, z:0})
      });
  };

  window.addEventListener('mousemove', captureMouse);
  window.addEventListener('mousedown', captureMouse);
  window.addEventListener('mouseup', captureMouse);
  iframe?.addEventListener('load', () => {
      iframe.contentWindow?.addEventListener('mousemove', captureMouse);
      iframe.contentWindow?.addEventListener('mousedown', captureMouse);
      iframe.contentWindow?.addEventListener('mouseup', captureMouse);
  });
}

bootGoldenMaster();

document.addEventListener('DOMContentLoaded', bootGoldenMaster);